export const findFirstNameOfOffice = (value: string | undefined, officeLabel?: string) => {
  if (!value || !officeLabel) return ''

  let officeValue = value.slice(0, 2)
  let officeValueFull = value

  if (officeValueFull === '7105') return '강화군'
  if (officeValueFull === '6513') return '울릉도'
  if (officeValueFull === '6520') return '전라남도 장흥'
  if (officeValueFull === '6506') return '전라북도 정읍'
  if (officeValueFull === '6517') return '전라남도 진도'
  if (officeValueFull === '6522') return '경상남도 창원'
  if (officeValueFull === '6514') return '경상남도 통영'
  if (officeValueFull === '6515') return '전라남도 함평'
  if (officeValueFull === '1803') return '전주시'
  if (officeValue === '48') return '경북 구미시'
  if (officeValue === 'CN') return '대전광역시'
  if (officeValue === '60') return '광주광역시'
  if (officeValue === '26') return '경기 남양주'
  if (officeValue === 'A9') return '전라남도 무안군'
  if (officeValue === 'VK') return '경기 용인시'
  if (officeValue === 'XI') return '서울'
  if (officeValue === '50') return '경상남도 산청군'
  if (officeValue === 'C8') return '서울'
  if (officeValue === 'A2') return '경상남도 하동'
  if (officeValue === '23') return '논산'
  if (officeValue === '65') return '경상북도 예천'
  if (officeValue === '37') return '충청북도 옥천'
  if (officeValue === '88') return '경기도 의정부'

  return officeLabel.slice(0, 2)
}
